import ls from '../../library/localStorage';

export default {
  namespaced: true,
  state: {
    notification: ls.get('notification') || {},
  },
  getters: {
    activeNotification(state) {
      return state.notification;
    },
  },
  mutations: {
    setIsReadNotification(state, data) {
      state.notification = data;
    },
  },
  actions: {
    setIsReadNotification({ state, commit }, data) {
      commit('setIsReadNotification', data);
      ls.set('notification', state.notification);
    },
  },
};
